import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Stack, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, Tabs, Tab, TableSortLabel
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

export function SkisTable({ skis, onDetail }) {
  const [orderBy, setOrderBy] = useState('ski_number');
  const [order, setOrder] = useState('asc');

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const sortedSkis = [...skis].sort((a, b) => {
    if (orderBy === 'fa' || orderBy === 'hr') {
      const aVal = parseFloat(a[orderBy]) || 0;
      const bVal = parseFloat(b[orderBy]) || 0;
      return order === 'asc' ? aVal - bVal : bVal - aVal;
    }
    // Default: ski_number
    return order === 'asc' ? a.ski_number - b.ski_number : b.ski_number - a.ski_number;
  });

  return (
    <TableContainer component={Paper} sx={{ mb: 4, borderRadius: 2, boxShadow: 2, width: '100%', minWidth: 600 }}>
      <Table sx={{ width: '100%' }}>
        <TableHead>
          <TableRow sx={{ background: '#f5f5f5' }}>
            <TableCell>Ski #</TableCell>
            <TableCell>Brand</TableCell>
            <TableCell sortDirection={orderBy === 'fa' ? order : false}>
              <TableSortLabel
                active={orderBy === 'fa'}
                direction={orderBy === 'fa' ? order : 'asc'}
                onClick={() => handleSort('fa')}
              >
                FA
              </TableSortLabel>
            </TableCell>
            <TableCell sortDirection={orderBy === 'hr' ? order : false}>
              <TableSortLabel
                active={orderBy === 'hr'}
                direction={orderBy === 'hr' ? order : 'asc'}
                onClick={() => handleSort('hr')}
              >
                HR
              </TableSortLabel>
            </TableCell>
            <TableCell>Grind</TableCell>
            <TableCell>Mold</TableCell>
            <TableCell>Year</TableCell>
            <TableCell align="center">Details</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedSkis.map((ski) => (
            <TableRow key={ski.id} hover>
              <TableCell>{ski.ski_number}</TableCell>
              <TableCell>{ski.brand}</TableCell>
              <TableCell>{ski.fa}</TableCell>
              <TableCell>{ski.hr}</TableCell>
              <TableCell>{ski.grind}</TableCell>
              <TableCell>{ski.mold}</TableCell>
              <TableCell>{ski.year_made}</TableCell>
              <TableCell align="center">
                <Stack direction="row" spacing={1} justifyContent="center">
                  <IconButton size="small" onClick={() => onDetail(ski)}><InfoIcon /></IconButton>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function SkiDetailModal({ open, onClose, ski }) {
  const [tab, setTab] = useState(0);
  
  // Determine brand-specific field labels
  const isFischer = ski?.brand === 'Fischer';
  const isSalomonAtomic = ['Salomon', 'Atomic'].includes(ski?.brand);
  const isRossignol = ski?.brand === "Rossignol";
  
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Ski #{ski?.ski_number} Details</DialogTitle>
      <DialogContent>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2 }}>
          <Tab label="Info" />
        </Tabs>
        {tab === 0 && ski && (
          <TableContainer component={Paper} sx={{ my: 2, borderRadius: 2, boxShadow: 1 }}>
            <Table size="small">
              <TableBody>
                <TableRow><TableCell sx={{ fontWeight: 600 }}>Brand</TableCell><TableCell>{ski.brand}</TableCell></TableRow>
                {isFischer && (
                  <>
                    <TableRow><TableCell sx={{ fontWeight: 600 }}>FA</TableCell><TableCell>{ski.fa}</TableCell></TableRow>
                    <TableRow><TableCell sx={{ fontWeight: 600 }}>HR</TableCell><TableCell>{ski.hr}</TableCell></TableRow>
                  </>
                )}
                {isSalomonAtomic && (
                  <>
                    <TableRow><TableCell sx={{ fontWeight: 600 }}>MF</TableCell><TableCell>{ski.mf}</TableCell></TableRow>
                    <TableRow><TableCell sx={{ fontWeight: 600 }}>H4</TableCell><TableCell>{ski.h4}</TableCell></TableRow>
                  </>
                )}
                {isRossignol && (
                  <>
                    <TableRow><TableCell sx={{ fontWeight: 600 }}>Flex</TableCell><TableCell>{ski.rossi_flex}</TableCell></TableRow>
                    <TableRow><TableCell sx={{ fontWeight: 600 }}>Height</TableCell><TableCell>{ski.rossi_height}</TableCell></TableRow>
                  </>
                )}
                <TableRow><TableCell sx={{ fontWeight: 600 }}>Grind</TableCell><TableCell>{ski.grind}</TableCell></TableRow>
                <TableRow><TableCell sx={{ fontWeight: 600 }}>Mold</TableCell><TableCell>{ski.mold}</TableCell></TableRow>
                <TableRow><TableCell sx={{ fontWeight: 600 }}>Base</TableCell><TableCell>{ski.base}</TableCell></TableRow>
                <TableRow><TableCell sx={{ fontWeight: 600 }}>Length</TableCell><TableCell>{ski.ski_length_cm}</TableCell></TableRow>
                <TableRow><TableCell sx={{ fontWeight: 600 }}>Year Made</TableCell><TableCell>{ski.year_made}</TableCell></TableRow>
                <TableRow><TableCell sx={{ fontWeight: 600 }}>Type</TableCell><TableCell>{ski.type}</TableCell></TableRow>
                <TableRow><TableCell sx={{ fontWeight: 600 }}>Serial Number</TableCell><TableCell>{ski.serial_number}</TableCell></TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
} 